<header class="mainHeader">
    <a  class="logo">
        <span class="logoMini">
           <img [src]="configService.logoPath" alt="Wolters Kluwer" title="Wolters Kluwer" width="100">
    </span>
        <span class="logoLg">
            <img [src]="configService.logoPath" alt="Wolters Kluwer" width="200" height="">
        </span>
    </a>
    <nav class="navbar navbar-expand-lg">
        
        <div class="container-fluid p-0 d-flex justify-content-between">
                <button type="button" id="sidebarCollapse" class="toggleBtn desktopView"  (click)="onClick()">
                    <i class="fa fa-bars"></i>
                </button>
                <ul class="navbar-nav">
                    <!-- *appPermissionDirective="[menu, '0']" -->
                    <li class="nav-item  ps-3" (click)="addClassActive()" *ngIf="workbenchPermissionList && workbenchPermissionList != '0'">
                        <a class="nav-link" routerLink="/Workbench" routerLinkActive="active">
                            RCM Workbench
                        </a>
                    </li>
                    <li class="nav-item" (click)="addClassActive()" *ngIf="rcmRecordPermissionList && rcmRecordPermissionList != '0'">
                        <a class="nav-link " routerLink="/RLSearch" routerLinkActive="active">
                            Search RL RCM Records
                        </a>
                    </li>
                    
                    <li class="nav-item  ps-3" (click)="addClassActive()" *ngIf="insACQworkbenchPermissionList && insACQworkbenchPermissionList != '0'">
                        <a class="nav-link" routerLink="/WorkbenchInsuranceACQ" routerLinkActive="active">
                            Insurance - ACQ Workbench
                        </a>
                    </li>
                    <li class="nav-item" (click)="addClassActive()" *ngIf="insACQRecordPermissionList && insACQRecordPermissionList != '0'">
                        <a class="nav-link " routerLink="/RLSearchInsuranceACQ" routerLinkActive="active">
                            Search RL Insurance - ACQ Records
                        </a>
                    </li>
                    <li class="nav-item ps-3" (click)="addClassActive()" *ngIf="insuranceFormworkbenchPermissionList && insuranceFormworkbenchPermissionList != '0'">
                        <a class="nav-link " routerLink="/InsuranceFormWorkbench" routerLinkActive="active">
                            Workbench Insurance Form
                        </a>
                    </li>
                    <li class="nav-item" (click)="addClassActive()" *ngIf="insuranceFormRecordPermissionList && insuranceFormRecordPermissionList != '0'">
                        <a class="nav-link " routerLink="/RLSearchInsuranceForm" routerLinkActive="active">
                            Search RL Insurance - Form Records
                        </a>
                    </li>
                    <li class="nav-item ps-3" (click)="addClassActive()" *ngIf="mceworkbenchPermissionList && mceworkbenchPermissionList != '0'">
                        <a class="nav-link " routerLink="/WorkbenchMCE" routerLinkActive="active">
                            Workbench MCE
                        </a>
                    </li>
                    <li class="nav-item" (click)="addClassActive()" *ngIf="mceRecordPermissionList && mceRecordPermissionList != '0'">
                        <a class="nav-link " routerLink="/RLSearchMCE" routerLinkActive="active">
                            Search RL MCE Records
                        </a>
                    </li>
                </ul>
                
                <!-- <ul class="navbar-nav">

                    
                  
                </ul> -->
            <div class="topNavigationMenu">
                <ul class="nav navbar-nav ml-auto">
                  
                    <!-- <li class="nav-item d-inline-block">
                        <a class="menuLink">
                            <img [src]="configService.notificationIconPath" alt="" width="20" height="">
                            <span class="indicator">1</span>
                        </a>
                    </li> -->
                    <li class="nav-item">
                        <div class="btn-group" dropdown>
                            <button id="userDropdownBtn" dropdownToggle type="button" class="dropdown-toggle"
                                aria-controls="userDropdownBox">
                                <img [src]="configService.userIconPath" alt="" width="32" height="">
                                <span class="text-dark userName ms-1 me-2 pe-1">{{headerService.user?.FirstName}} {{headerService.user?.LastName}}</span>
                                <span class="caret ms-2"></span>
                            </button>
                            <ul id="userDropdownBox" *dropdownMenu class="dropdown-menu" role="menu"
                                aria-labelledby="button-basic">
                                <!-- <li role="menuitem"><a class="dropdown-item" >Profile</a></li> -->
                                <li role="menuitem"><a class="dropdown-item" (click)="ShowChangePasswordBox()">Change Password</a></li>
                          
                                <li role="menuitem"><a class="dropdown-item" (click)="Logout()">Logout</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
    </nav>
    
</header>
<app-loader [showLoader]="showLoader"></app-loader>